import fetch from 'isomorphic-fetch';
import errorHandler from 'utils/errorHandler';

import { DY_COOKIE_NAME } from '../consts';
import { isCookieAllowed, registerConsentChangedCallback } from 'apps/cookieConsent/utils';

import { config } from 'api';
import { getUserDataFromCookies } from '../utils';

class DynamicYieldAPI {
  // external DY object loaded from DynamicYield scripts
  dy = {}

  // DY Enabled
  isDYEnabled = false;

  // Events to trigger when API is ready
  delayedEvents = [];

  get isApiReady() {
    return this.isDYEnabled && this.dy && typeof this.dy.API === 'function';
  }

  setEnabled = (enabled) => {
    this.isDYEnabled = enabled;
    if (!this.isDYEnabled) {
      this.clearDelayedEvents();
    }
  }

  clearDelayedEvents = () => {
    this.delayedEvents = [];
  }

  reportDelayedEvents = () => {
    if (this.delayedEvents.length > 0) {
      this.delayedEvents.forEach((eventObject) => {
        const { event, properties } = eventObject;
        this.reportEvent(event, properties);
      });
    }
  }

  onLoaded = (dy) => {
    this.dy = dy;
    this.setActiveConsent(true);
    this.reportDelayedEvents();
  }

  onError = (e) => {
    this.clearDelayedEvents();
    errorHandler(e);
  }

  setActiveConsent = (initial) => {
    if (this.isApiReady) {
      const isDyCookieAllowed = isCookieAllowed(DY_COOKIE_NAME);
      this.dy.userActiveConsent = { accepted: isDyCookieAllowed };
      window.DYO.ActiveConsent.updateConsentAcceptedStatus(isDyCookieAllowed);

      if (initial) {
        registerConsentChangedCallback(this.setActiveConsent.bind(this, false));
      }
    }
  }

  setContext = (context) => {
    if (this.isApiReady) {
      this.dy.recommendationContext = context;
    }
  }

  reportEvent = async (event, properties) => {
    if (this.isApiReady) {
      const { dynamicYield: { api } = {} } = config;
      const { key, url } = api || {};
      const isUserOptOut = window.DYO.ActiveConsent.isUserOptOut();
      let cookieData;

      if (key && url && !isUserOptOut) {
        try {
          cookieData = await getUserDataFromCookies(isUserOptOut);
        } catch {
          cookieData = {};
        }

        fetch(`${url}/event`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'DY-API-Key': key,
          },
          body: JSON.stringify({
            ...cookieData,
            events: [{
              name: event.name,
              properties: {
                ...(event.type && { dyType: event.type }),
                ...properties,
              },
            }],
          }),
        }).catch(errorHandler);
      }
    }
  }

  delayEvent = (event, properties) => {
    this.delayedEvents.push({ event, properties });
  }
}

const dynamicYieldAPI = new DynamicYieldAPI();

export default dynamicYieldAPI;
